import { AxiosInstance } from 'axios';
import {
  BetaFeatureRolloutRepository,
  BetaFeatureRolloutResponse,
} from '@/model/repository/manager/facility/BetaFeatureRolloutRepository';

export default (Repository: AxiosInstance) =>
  (resource: string): BetaFeatureRolloutRepository => ({
    get(featureName: string) {
      return Repository.get<BetaFeatureRolloutResponse>(`${resource}/${featureName}`);
    },
  });
